import React from 'react';
import PropTypes from 'prop-types';
import {
  TabContent,
  TabPane,
} from 'reactstrap';

import DownloadRequestEditMainEdit from './MainEdit';

const DownloadRequestEditTabContent = ({ activeTab, ...props }) => (
  <TabContent activeTab={activeTab} className="settings-tab-content download-request">
    <TabPane tabId="1">
      <DownloadRequestEditMainEdit
        {...props}
      />
    </TabPane>
  </TabContent>
);

DownloadRequestEditTabContent.propTypes = {
  activeTab: PropTypes.string.isRequired,
};

export default DownloadRequestEditTabContent;
